import { BasicRequest } from "./basicRequest";

export class UpdateMoovConfigurationUsagePriceOverrideRequest extends BasicRequest{
    public moovConfigurationId!:number;
    public usagePriceOverride!:number;
}